var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticStyle:{"--bs-breadcrumb-divider":"'>'"},attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.listNavs),function(nav,index){return _c('li',{key:index,staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":nav.link}},[_vm._v(_vm._s(nav.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }